import { useTranslation } from 'react-i18next';

import { ErrorBoundary } from '@/shared/features/error/components/error-boundary/error-boundary';

export const NoPermission = () => {
  const { t } = useTranslation();

  return (
    <ErrorBoundary
      title={t('ui:no_permission_title')}
      message={t('ui:no_permission_message')}
    />
  );
};
